import { z } from "zod";

import { validationTxHashErrorMessages } from "../i18n/validation-error-codes";

export const txHashSchema = z
  .string()
  .min(1, validationTxHashErrorMessages.required.id);
